import api from "../../api/index";
import { utilityActions } from "../reducers/utilitySlice";

export const setPreviousPageURLAction = (previousPage: string) => {
  return async (dispatch: any) => {
    dispatch(
      utilityActions.setPreviousPage({
        previousPage: previousPage,
      })
    );
  };
};